
// 评价卡片
import { mapGetters } from 'vuex'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import comment from './comment/index'
import buyerBindAccount from './buyer/bindAccount'
import buyerVerifyAccount from './buyer/verifyAccount'
import fromImage from './comment/fromImage'
// 卖家卡片
import sellerSubmitInfo from './seller/submitInfo'
import sellerChangeBindAccount from './seller/changeBindAccount'
import sellerProvidePay from './seller/providePay'
import sellerConfirmInfo from './seller/comfirmInfo'
// 取消订单
import cancelOrder from './cancelOrder'

// 通用
import reTrade from './common/reTrade'
import thirdBlack from './common/thirdBlack'
import blackCancel from './common/blackCancel'
import orderApprove from './common/orderApprove'
import reProvidePay from './common/reProvidePay'
import buyerReadReport from './buyer/readReport'
import progressCard from './common/progress'
import commonCard from './common/common'
import readyPay from './common/readyPay'
import { groupMembership } from '@/plugins/imMethod'
import { dirtyHTML } from '@/utils/filter-dirty-html'
// 买家
import buyerConfirmInfo from './buyer/confirmInfo'

export default {
    name: 'Comment',
    components: {
        comment,
        fromImage,

        buyerBindAccount,
        buyerVerifyAccount,

        sellerChangeBindAccount,
        sellerSubmitInfo,
        sellerProvidePay,

        cancelOrder,

        reTrade,
        thirdBlack,
        blackCancel,
        orderApprove,
        reProvidePay,

        buyerReadReport,
        progressCard,
        commonCard,
        readyPay,
        ElImageViewer,

        buyerConfirmInfo,
        sellerConfirmInfo
    },
    inject: ['getFormComp', 'downloadModel'],
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            bottomDrawerShow: false,
            bottomDrawerData: {},
            // 图片预览
            showPreview: false,
            picList: [],
            picIndex: 0
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            imOrderInfo: 'ry/imOrderInfo',
            imExpansion: 'ry/imExpansion'
        }),
        displayData () {
            console.log(1);
            
            if (!this.content.displayData) { return {} }
            const displayData = {}
            this.content.displayData.forEach(item => {
                displayData[item.fieldType] = item
            })
            const arr = ["UNIQUE_MARK", "BLACKLIST_QUERY_TIME"]
            displayData.dataAll = this.content.displayData.filter(e => !arr.includes(e.fieldType))

            return displayData
        },
        expansion () {
            return {
                ...this.message.expansion,
                ...(this.imExpansion[this.message.messageUId] || {})
            }
        },
        content () {
            const content = this.message?.content?.content || {}
            let { button_0, button_1 } = this.expansion || {}
            button_0 = JSON.parse(button_0 || '{}').click === false
            button_1 = JSON.parse(button_1 || '{}').click === false
            return {
                ...content,
                richText: content.richText ? dirtyHTML(content.richText) : '',
                buttons: (content.buttons || []).map((item, index) => ({
                    ...item,
                    disabled: !index ? button_0 : button_1
                }))
            }
        },
        mentionedUser () {
            return this.message?.content?.mentionedInfo?.mentionedContent || ''
        },
        canSeeBtns () {
            return Boolean(this.content.buttons.length && this.content.permissions.includes(String(this.userinfo.id)))
        },
        isSeller () {
            return +this.imOrderInfo.sellerId === +this.userinfo.id
        },
        ComponentMap () {
            return {
                // 评价卡片
                EVALUATE: comment,
                FORM_FIELD_DISPLAY: fromImage,
                PARTIAL_REFUND_OF_THE_ORDER:fromImage,
                

                // 买家绑定账号卡片
                BUYER_CONFIRM_CHANGE_BIND: buyerBindAccount,
                // 买家验证账号卡片
                BUYER_CHECK_NUMBER: buyerVerifyAccount,

                // 卖家卡片
                SELLER_PROVIDES_TRANSACTION_INFORMATION: sellerSubmitInfo,
                // 卖家操作换绑
                SELLER_CHANGES_THE_BINDING: sellerChangeBindAccount,
                // 换绑手机变更卡片
                IM_CHANGE_PHONE_NUMBER: sellerChangeBindAccount,
                // 卖家提供放款资料
                SELLER_APPLICATION_LENDERS: sellerProvidePay,

                // 取消订单
                // 卖家违约线上支付
                SELLER_DEFAULTS_ONLINE_PAYMENT: cancelOrder,
                // 买家违约线上支付
                BUYER_DEFAULTS_ON_ONLINE_PAYMENT: cancelOrder,
                // 无违约线上支付
                NO_DEFAULT_ONLINE_PAYMENT: cancelOrder,
                // 卖家违约线下支付
                SELLER_DEFAULTS_TRANSFER_PAYMENT: cancelOrder,
                // 买家违约线下支付
                BUYER_DEFAULT_TRANSFER_PAYMENT: cancelOrder,
                // 无违约线下支付
                NO_DEFAULT_TRANSFER_PAYMENT: cancelOrder,

                // 重复交易
                REPEAT_TRANSACTIONS: reTrade,
                // 三方黑号 
                THREE_SIDES_BLACK: thirdBlack,
                // 黑号取消订单
                BLACK_NUMBER_CANCELS_THE_ORDER: blackCancel,
                // 查黑查重异常卡片
                THREE_BLACK_OR_REPEAT_TRANSACTIONS: blackCancel,
                // 订单审核
                ORDER_REVIEW: orderApprove,
                // 重新提供放款资料
                RESUBMIT_THE_PAYOUT_ACCOUNT: reProvidePay,
                RESUBMIT_THE_PAYOUT_ACCOUNT_GENERAL: reProvidePay,
                RESUBMIT_PAYOUT_ACCOUNT_REFUND: reProvidePay,
                RESUBMIT_PAYOUT_ACCOUNT_REFUND_GENERAL: reProvidePay,
                // 买家查看验号报告
                ACCOUNT_VERIFICATION_REPORT: buyerReadReport,
                // 买家信息确认 - 自选号
                ORDER_INFORMATION_CONFIRMATION_BUYER: buyerConfirmInfo,
                // 卖家信息确认 - 自选号
                ORDER_INFORMATION_CONFIRMATION_SELLER: sellerConfirmInfo,
                // 交易进度
                PROGRESS: progressCard,
                //放款准备
                SELLER_COLLECTION_ACCOUNT_NUMBER_GENERAL: readyPay,
                BUYER_DEFAULTS_ON_ONLINE_PAYMENT_GENERAL: cancelOrder,
                SELLER_DEFAULTS_ONLINE_PAYMENT_GENERAL: cancelOrder,
                NO_DEFAULT_ONLINE_PAYMENT_GENERAL: cancelOrder
            }
        }
    },
    methods: {
        groupMembership,
        workOrderClick (btnItem, index, title) {
            // 先判断doubleConfirmation是否为true
            return new Promise(resolve => {
                if (btnItem.doubleConfirmation) {
                    this.$confirm(
                        btnItem.popUpWriter || '本卡片为交易重点环节，请仔细确认卡片内交易操作是否完成，若未完成请点击取消，有疑问请及时@客服协助处理！',
                        btnItem.popUpTitle || '二次确认', {
                            confirmButtonText: '确认完成',
                            confirmButtonClass: 'confirmButtonClass',
                            dangerouslyUseHTMLString: true
                        }).then(() => resolve())
                } else {
                    resolve()
                }
            }).then(() => {
                switch (btnItem.strategy) {
                case 'NEXT_CARD':
                case 'NEXT_NODE':
                case 'AWAKE_CS':
                    this.onNextStep(this.content, index)
                    break
                case 'JUMP_LINK':
                    // 判断是否是小米授权
                    if (this.content.type == 'SELLER_AUTHORIZATION_MI_ACCOUNT' || this.content.type == 'BUYER_AUTHORIZATION_MI_ACCOUNT') {
                        this.downloadModel('请前往应用中心下载盼之代售APP或在手机浏览器打开m7.pzds.com进行账号授权！')
                    } else if (['SELLER_COMPENSATION_AUTHENTICATION', 'UPDATED_COMPENSATION_INFORMATION'].includes(this.content.type)) {
                        this.downloadModel('请前往应用中心下载盼之代售APP或在手机浏览器打开m7.pzds.com进行包赔认证！')
                    } else if (btnItem.url && btnItem.url.includes('/details/')) {
                        const _urlReplace = '/details/'
                        const _url = btnItem.url.replace(new RegExp(`^.*?${_urlReplace}`), '')
                        window.open(`${location.origin}/helpCenter/${_url}`)
                    } else {
                        window.open(btnItem.url)
                    }
                    break
                case 'SUBMIT':
                    this.getForm({ ...this.content, title: title || this.content.title }, index)
                    break
                case 'PAY':
                    this.getPayOrder(this.content)
                    break
                // 抽屉
                case 'BOTTOM_DRAWER':
                    this.bottomDrawerShow = true
                    this.bottomDrawerData = { ...btnItem }
                    this.$nextTick(() => {
                        this.picList = this.getImgSrc(this.bottomDrawerData.drawersText)
                    })
                    break
                // 跳转订单
                case 'JUMP_ORDER':
                    if (btnItem.isSeller) {
                        this.$router.push('/account/sellerList?status=TRADING')
                    } else {
                        this.$router.push(`/account/buyerDetails?orderNo=${this.content.orderNo}`)
                    }
                    break
                default:
                    break
                }
            })
        },
        onNextStep (item, index) {
            console.log(item, index, 6666)
            const data = {
                buttonIndex: index,
                buttonStrategy: item.buttons[index].strategy,
                idToken: item.buttons[index].idToken,
                formDataActionList: undefined,
                nodeId: item.nodeId,
                cardId: item.cardId,
                orderId: item.orderId,
                type: item.type
            }
            this.$api.workorderCardButtonSubmit(data).then(res => {
                if (res.success) {
                    this.$message.success('操作成功')
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        getForm (item, index) {
            let formData = {}
            switch (item.type) {
            // 取消交易，买家提供收款账号
            case 'CANCEL_DEAL_BUYER_RECEIVABLES_ACCOUNT':
                if (this.content.permissions == this.userinfo.id) {
                    this.$api.getReceiverAccountApi({ orderId: this.content.orderId }).then(res => {
                        if (!res.success) {
                            return this.$message.error(res.info)
                        }

                        if (res.data.isSingleAccount || res.data.isSingleAccount === null) {
                            formData = {
                                buttonIndex: index,
                                buttonStrategy: this.content.buttons[index].strategy,
                                idToken: this.content.buttons[index].idToken,
                                nodeId: this.content.nodeId,
                                cardId: this.content.cardId,
                                orderId: this.content.orderId,
                                type: this.content.type,
                                title: this.content.title,
                                isBuy: 1,
                                ...res.data
                            }
                            this.regularFrom(formData, item)
                        } else {
                            this.$message.warning('当前订单为多账户收款订单，请联系客服处理！')
                        }
                    })
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'SELLER_COLLECTION_ACCOUNT_NUMBER':
                //  卖家收款账号校验
                if (item.permissions == this.userinfo.id) {
                    formData = {
                        buttonIndex: index,
                        buttonStrategy: item.buttons[index].strategy,
                        idToken: item.buttons[index].idToken,
                        nodeId: item.nodeId,
                        cardId: item.cardId,
                        orderId: item.orderId,
                        type: item.type,
                        title: item.title,
                        isBuy: 2
                    }
                    this.regularFrom(formData, item)
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'SELLER_COLLECTION_ACCOUNT_ERROR':
                //  账户异常重新提交
                if (item.permissions == this.userinfo.id) {
                    formData = {
                        buttonIndex: index,
                        buttonStrategy: item.buttons[index].strategy,
                        idToken: item.buttons[index].idToken,
                        nodeId: item.nodeId,
                        cardId: item.cardId,
                        orderId: item.orderId,
                        type: item.type,
                        title: item.title,
                        isBuy: 3
                    }
                    this.regularFrom(formData, item)
                } else {
                    this.$message.error('无权查看')
                }
                break
            case 'BUYER_COLLECTION_ACCOUNT_ERROR':
                //  账户异常重新提交
                if (this.content.permissions == this.userinfo.id) {
                    this.$api.getReceiverAccountApi({ orderId: this.content.orderId }).then(res => {
                        if (!res.success) {
                            return this.$message.error(res.info)
                        }
                        if (res.data.isSingleAccount || res.data.isSingleAccount === null) {
                            formData = {
                                buttonIndex: index,
                                buttonStrategy: this.content.buttons[index].strategy,
                                idToken: this.content.buttons[index].idToken,
                                nodeId: this.content.nodeId,
                                cardId: this.content.cardId,
                                orderId: this.content.orderId,
                                type: this.content.type,
                                title: this.content.title,
                                isBuy: 4,
                                ...res.data
                            }
                            this.regularFrom(formData, item)
                        } else {
                            this.$message.warning('当前订单为多账户收款订单，请联系客服处理！')
                        }
                    })
                } else {
                    this.$message.error('无权查看!')
                }
                break
            default:
                // 动态表单
                console.log(item)
                if (item.permissions.includes(String(this.userinfo.id))) {
                    const data = {
                        buttonIndex: index,
                        cardId: item.cardId,
                        nodeId: item.nodeId,
                        orderId: item.orderId
                    }
                    this.$api.workorderCardFormData(data).then(res => {
                        console.log('是这个吗？？？');
                        
                        if (res.success) {
                            const _arr = []
                            const formDataFiledVOList = res.data?.formDataFiledVOList || []
                            formDataFiledVOList.forEach((v, i) => {
                                if (!v || typeof v !== 'object') return
                                
                                // 如果字段名称为UID且有值，则禁止编辑
                                const isUidField = (v.name === 'UID' || v.fieldType === 'UID')
                                const hasValue = v.value !== null && v.value !== undefined && v.value !== ''
                                const shouldDisable = isUidField && hasValue
                                
                                _arr.push({
                                    ...v,
                                    cardButtonSubmit: v.dataType,
                                    disabled: shouldDisable ? true : (v.disabled !== undefined ? v.disabled : false)
                                })
                            })
                            formData = {
                                formDataActionList: _arr,
                                warning: res.data.warning,
                                buttonIndex: index,
                                buttonStrategy: item.buttons[index].strategy,
                                idToken: item.buttons[index].idToken,
                                nodeId: item.nodeId,
                                cardId: item.cardId,
                                orderId: item.orderId,
                                type: item.type,
                                title: item.title
                            }
                            this.getFormComp(formData)
                        } else {
                            this.$message.error(res.info)
                        }
                    })
                } else {
                    this.$message.error('无权查看')
                }
                break
            }
        },
        // 获取图片列表
        getImgSrc (richtext) {
            const imgList = []
            richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (_, capture) => {
                imgList.push(capture)
            })
            return imgList
        },
        // 预览图片
        previewImage (event, picList) {
            if (event.target.nodeName !== 'IMG') { return }
            const imgUrl = event.target.src
            this.picList = picList
            this.picIndex = picList.findIndex(item => item === imgUrl)
            this.$nextTick(() => {
                this.showPreview = true
            })
        },
        onCloseViewer () {
            this.showPreview = false
        }
    }
}
